export default __webpack_public_path__ + "static/media/texture.983106be.jpg";